"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TooltipMessage = exports.CompareContainerText = exports.CompareContainer = exports.EmptyInputFieldsWrapper = exports.RoomSizeInputWrapper = exports.HelperTextWrapper = exports.ResultProductWrapper = exports.NoMatchingProductContent = exports.NoMatchingProductTitle = exports.NoMatchingProductGreyWrapper = exports.NoMatchingProductWrapper = exports.LoaderWrapper = exports.RoomWrapper = exports.RoomLabel = exports.SelectWrapper = exports.InputWrapper = exports.ResultantWrapper = exports.ButtonWrapper = exports.Master = exports.SectionWrapper = exports.CollapseWrapper = exports.ResultVariantSection = exports.SidePanel = exports.ResultWrapper = exports.MatchMessage = exports.MatchMessageWrapper = exports.Option = exports.ResultSectionWrapper = exports.ResultSectionContainer = exports.ProductSelectorSearchContainer = exports.Wrapper = exports.HorizontalLine = exports.Title = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const colors_1 = require("../../../theme/colors");
exports.Title = styled_components_1.default.div `
  font-family: SwegonBrown;
  font-style: normal;
  line-height: 30px;
  display: flex;
  align-items: center;
  padding: 8px 0;

  label {
    font-weight: bold;
    font-size: 36px;
  }
`;
exports.HorizontalLine = styled_components_1.default.hr `
  order: 6;
  align-self: stretch;
  flex-grow: 0;
  margin: 8px 0px;
  border: 1px solid #f5f5f5;
  background-color: #f5f5f5;
`;
exports.Wrapper = styled_components_1.default.div `
  padding: 20px 0;
  width: 100%;
  margin: 0 auto;
  height: fit-content;
  min-width: 964px;
  max-width: 1167px;
`;
exports.ProductSelectorSearchContainer = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  margin: 20px 40px;
`;
exports.ResultSectionContainer = styled_components_1.default.div `
  display: flex;
  background-color: #f5f5f5;
  height: fit-content;
  flex-direction: column;
  box-shadow: inset 0px 0px 1px rgb(0 0 0 / 11%), inset 0px 0px 3px rgb(0 0 0 / 10%);
`;
exports.ResultSectionWrapper = styled_components_1.default.div `
  display: flex;
  height: fit-content;
  flex-direction: column;
  max-width: 1400px;
  margin: 0 auto;
  width: 100%;
`;
exports.Option = styled_components_1.default.option ``;
exports.MatchMessageWrapper = styled_components_1.default.div `
  margin-top: 20px;
  padding: 10px 20px;
  position: ${(props) => (props.$isComparisonEnabled ? "sticky" : "static")};
  top: 50px;
  background: #f5f5f5;
  z-index: 5;
`;
exports.MatchMessage = styled_components_1.default.div `
  font-family: SwegonBrown;
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  align-items: center;
  color: ${colors_1.BLACK};
  margin: 0 0 0 315px;

  @media (max-width: 1150px) {
    margin: 0 0 0 220px;
  }
`;
exports.ResultWrapper = styled_components_1.default.div `
  display: flex;
`;
exports.SidePanel = styled_components_1.default.div `
  display: flex;
  width: 100%;
  margin: 20px;
  flex-direction: column;
  min-width: 226px;
  max-width: 275px;
  @media (max-width: 1160px) {
    margin: 20px 5px;
  }
`;
exports.ResultVariantSection = styled_components_1.default.div `
  display: flex;
  width: 100%;
  flex-direction: column;
  margin: 20px;
  min-width: 793px;
  max-width: 1100px;

  @media (max-width: 1160px) {
    margin: 20px 5px;
    min-width: 730px;
  }
`;
exports.CollapseWrapper = styled_components_1.default.div `
  display: flex;
`;
exports.SectionWrapper = styled_components_1.default.div `
  display: flex;
`;
exports.Master = styled_components_1.default.div `
  display: flex;
  width: 100%;
  flex-wrap: wrap;
  gap: 3px;
  > div {
    width: 100%;
  }
`;
exports.ButtonWrapper = styled_components_1.default.div `
  padding: 45px 0;
  display: flex;
  justify-content: center;
`;
exports.ResultantWrapper = styled_components_1.default.div `
  margin-left: auto;
  min-width: 180px;

  :empty {
    display: none;
  }
`;
exports.InputWrapper = styled_components_1.default.div `
  margin-right: 10px;
  max-width: 310px;
`;
exports.SelectWrapper = styled_components_1.default.div `
  margin-right: 10px;
  max-width: 300px;
  width: 100%;
`;
exports.RoomLabel = styled_components_1.default.div `
  font-family: SwegonBrown;
  font-style: normal;
  font-weight: bold;
  font-size: 14px;
  line-height: 20px;
  color: ${colors_1.GREY4};
  margin-left: 10px;
`;
exports.RoomWrapper = styled_components_1.default.div `
  display: flex;
  align-items: center;
  padding: 20px 0;
`;
exports.LoaderWrapper = styled_components_1.default.div `
  display: flex;
  justify-content: center;
  width: 100%;

  > div,
  > div div {
    width: 32px;
    height: 32px;
  }
`;
exports.NoMatchingProductWrapper = styled_components_1.default.div `
  background: ${colors_1.WHITE};
  padding: 20px;
  display: flex;
  align-items: center;
  height: 100%;
  flex-direction: column;
`;
exports.NoMatchingProductGreyWrapper = styled_components_1.default.div `
  background-color: #f5f5f5;
  padding: 20px;
  display: flex;
  align-items: center;
  height: 100%;
  flex-direction: column;
  min-height: 400px;
`;
exports.NoMatchingProductTitle = styled_components_1.default.h2 `
  margin: 50px 0 0;
  font-size: 24px;
  font-weight: bold;

  label {
    font-size: 24px;
    font-weight: bold;
  }
`;
exports.NoMatchingProductContent = styled_components_1.default.div `
  display: block;
  max-width: 440px;
  text-align: center;
  margin-top: 8px;
  font-size: 16px;

  label {
    font-size: 16px;
  }
`;
exports.ResultProductWrapper = styled_components_1.default.div `
  background: ${colors_1.WHITE};
  height: 100%;
`;
exports.HelperTextWrapper = styled_components_1.default.label `
  display: block;
  margin: 3px 0 0 10px;
  color: ${colors_1.RED};
  font-size: 12px;
`;
exports.RoomSizeInputWrapper = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
`;
exports.EmptyInputFieldsWrapper = styled_components_1.default.div `
  font-size: 14px;
  font-style: italic;
  color: #f5f5f5;
`;
exports.CompareContainer = styled_components_1.default.div `
  display: flex;
  margin-left: auto;
  align-items: flex-end;

  button:first-child {
    color: ${colors_1.BLACK};
  }

  button + button {
    margin-left: 20px;
  }
`;
exports.CompareContainerText = styled_components_1.default.div `
  padding-left: 10px;
  cursor: pointer;
  font-size: 14px;
  font-weight: bold;
`;
exports.TooltipMessage = styled_components_1.default.div `
  color: ${colors_1.WHITE};
  background: ${colors_1.BLACK};
  border: 1px solid transparent;
  border-radius: 3px;
  padding: 8px 21px;
  opacity: 0.9;
  position: absolute;
  margin-right: 20px;

  display: inline-block;
  font-size: 13px;

  right: 210px;
  top: 3px;

  &:before {
    content: "";
    width: 0;
    height: 0;
    border-top: 8px solid transparent;
    border-bottom: 8px solid transparent;
    border-left: 8px solid ${colors_1.BLACK};
    right: -9px;
    top: 50%;
    margin-top: -7px;
    position: absolute;
  }
`;
//# sourceMappingURL=ProductSelectField.styles.js.map